import React from 'react';
import { createSvgIcon } from '../helpers';
export var CurvedArrowIcon = createSvgIcon(React.createElement("path", {
  fill: 'currentColor',
  d: 'M0 10c1.513-6.587 7-7.778 7-7.778V0l5 4.425-5 4.464V6.666C7 6.667 3.22 6.552 0 10z'
}), 'CurvedArrow');